import Dexie from "dexie";

export const db = new Dexie("novacheck_app");

// Version 45 - Original schema
db.version(45).stores({
    component_groups: "&id",
    components: "&id, &uuid",
    base_components: "&uuid,parent",
    danger_aspects: "&id",
    error_classifications: "&id",
    error_indications: "&id",
    forms: "&id, inspection_id, &uuid",
    forms_location_item_components: "&id, form_id, location_item_component_uuid",
    inspections: "&id, &uuid",
    installation_types: "&id",
    jobs: "id++, &uuid, status, &payload, [module+payload]",
    failed_jobs: "id++, &uuid",
    permanently_failed_jobs: "id++, &uuid",
    location_items: "&uuid, id, location_id,inspection_id,order_id,parent_uuid",
    location_item_components: "&uuid,id, parent_uuid, location_item_uuid, inspection_id",
    location_item_types: "&id",
    location_rotationfields: "&id",
    location_system_types: "&id",
    location_systems: "&uuid,location_systemable_uuid",
    measurement_types: "&id",
    measurement_instruments: "&id",
    measurement_instrument_types: "&id",
    measurements:
        "&uuid,id, location_item_component_uuid, inspection_id,measurement_type_id,[location_item_component_uuid+inspection_id]",
    observations:
        "&uuid,id, location_item_component_uuid, inspection_id,[location_item_component_uuid+inspection_id]",
    remarks: "&id,name",
    repair_periods: "&id",
    user: "&id",
    custom_remarks: "&uuid,&name",
    inspection_method_types: "&id",
    inspection_methods: "&id",
    inspection_statuses: "&id",
    answers: "&id, &uuid, inspection_id,form_id",
    answers_inspections: "&uuid, inspection_id, form_id",
    answers_location_item_components: "&uuid, form_id, location_item_component_uuid",
    documents: "&uuid, documentable_uuid",
    actions: "&uuid, actionable_uuid,inspection_id,status,priority",
    comments: "&uuid, action_uuid",
    notifications: "&id, read_at",
    images: "&uuid, imageable_uuid, s3_key, upload_status, sync_status",
    document_types: "&id",
    regulations: "&id",
    sync_regulations: "id++",
    measurement_type_revisions: "&id, measurement_type_id",
    projects: "&id, &uuid, inspection_id",
    customers: "&id, &uuid, inspection_id",
    locations: "&id, &uuid, inspection_id",
    inspector_users: "&id, inspection_id",
    samples: "&uuid, inspection_id, component_uuid",
    scios_codes: "&uuid, inspection_id",
    task_states: "++id, type, interrupted, timestamp",
});

// Version 46 - Add type index to jobs table for image sync notification queries
db.version(46).stores({
    jobs: "id++, &uuid, type, status, &payload, [module+payload]",
});

// Version 47 - Add type index to failed_jobs and permanently_failed_jobs tables for image sync notification queries
db.version(47).stores({
    failed_jobs: "id++, &uuid, type",
    permanently_failed_jobs: "id++, &uuid, type",
});
